import StoryblokClient from "storyblok-js-client";

let storyapi = null;

const storyblok = {
  namespaced: true,
  state: {
    story: {
      content: {
        body: []
      }
    },
    domains: [],
    token: null,
  },
  mutations: {
      setStory: (state, story) => {
        state.story = story;
      }
  },
  actions: {
    getStory: async ({ commit }, params) => {
      const story = await storyapi.get("cdn/stories/" + params.route, {
        version: params.draft ? 'draft' : 'published',
        from_release: params.release ? params.release : 0
      });
      commit('setStory', story.data.story);
    },
    getStoryById: async ({ commit }, params) => {
      const story = await storyapi.get("cdn/stories/" + params.id, {
          version: params.draft ? 'draft' : 'published',
          find_by: 'uuid',
          from_release: params.release ? params.release : 0
      });
      return story;
    },
    // eslint-disable-next-line no-unused-vars
    getDataSource: async ({ commit }, source) => {
        return storyapi.get('cdn/datasource_entries', {
            'datasource' : source
        });
    },
    getPath: async ({ dispatch }, route ) => {
      const domains = await dispatch('getDataSource','domain-mappings');
      const domain = domains.data.datasource_entries.find( v => v.name == window.location.hostname);
      const domainRoute = domain ? domain.value : '';
      const contentPath = route.params.first != 'channels' ? 'channels' + domainRoute + route.path : route.path;
      return contentPath;
    },
    loadConfig: async ({ dispatch }) => {
        const config = await dispatch('getDataSource','configuration');
        return config;
    },
    initStoryBlok: async ({ dispatch }, token) => {
      storyapi = new StoryblokClient({
        accessToken: token
      });
      window.storyblok.init({
        accessToken: token
      });
      return storyapi;
    }
  },
  getters: {
    domainPath: state => key => {

    }
  }
};
//
export default storyblok;
